export default __webpack_public_path__ + "static/media/312.3d08d30d.gif";